import { Component, OnInit, Input } from '@angular/core';
import { Session } from 'src/app/models/session';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/user.service';
import { ConfirmService } from '../confirm/confirm.service';
import { AgregarZonaService } from '../agregar-zona/agregar-zona.service';
import { AdminTicketReviewDialogService } from '../admin-ticket-review-dialog/admin-ticket-review-dialog.service';

@Component({
  selector: 'app-tecnico',
  templateUrl: './tecnico.component.html',
  styleUrls: ['./tecnico.component.css']
})
export class TecnicoComponent implements OnInit {

  constructor(public router: Router,public session: Session,private calificarTicket: AdminTicketReviewDialogService, private agregarZonaService: AgregarZonaService, private activatedRoute: ActivatedRoute, private toast: ToastrService, private service: UserService, private confirm: ConfirmService) { }

  @Input()
  tecnico;
  
  selectedZona;
  zonasPosibles = [];

  showZonas = false;
  showTickets = false;
  showSolicitudes = false;

  editedTecnico;

  ngOnInit() {
      this.activatedRoute.params.subscribe(d=>{
        this.service.getTecnico(d.id).subscribe(d=>{
          this.tecnico = d.tecnico;
          this.tecnico.asignaciones = d.asignaciones;
          this.tecnico.asignaciones.sort( (a,b) => { return a.fecha < b.fecha ? 1 : -1 } );

          if(this.session.zonas.length==0){
            this.service.getZones().subscribe(d=>{
              this.session.zonas = d;
              this.getZonasDisponibles();
            })
          }
          else{
            this.getZonasDisponibles();
          }
        }, er=>{
          this.toast.error("Error");
        })
      })
   
    
  }

  getZonasDisponibles(){
    if(!this.tecnico || this.session.zonas.length<1) return [];
    let ret = [];
    for(let z of this.session.zonas){
      if(this.tecnico.zonas.filter(x => { x.provincia == z.provincia && x.localidad == z.localidad}).length<1) ret.push(z);
    }
    if(ret.length>0)this.selectedZona = ret[0];
    
    this.zonasPosibles = ret;
  }

  agregarZona(){
    this.agregarZonaService.agregar("Agregar zona", "Indique la zona a agregarle al técnico", "Agregar", "Cancelar").then( zona =>{
      if(!zona || !zona.provincia || !zona.localidad) return;
      
      this.service.agregarZonaATecnico(this.tecnico, zona).subscribe(d=>{
        this.tecnico.zonas.push(zona);
        this.getZonasDisponibles();
      }, er=>{
        this.toast.error(er.error);
      });
    })
  }

  removeZona(zona){
    this.confirm.confirm("Remover zona", "Confirma que desea remover la zona " + zona.localidad + " al técnico?").then( confirmed => {
      if(!confirmed) return;
      this.service.removerZonaTecnico(this.tecnico, zona).subscribe(d=>{
        this.tecnico.zonas.splice(this.tecnico.zonas.findIndex(x=> x._id == zona._id ),1);
        this.getZonasDisponibles();
      }, er=>{
        this.toast.error(er.error);
      })
    })
   
  }

  getProvincias(){
    let ret = new Set();
    for(let z of this.tecnico.zonas){
      ret.add(z.provincia);
    }
    return ret;
  }


  getLocalidades(provincia){
    return this.tecnico.zonas.filter(x=> x.provincia == provincia);
  }


  edit(){
    this.editedTecnico = JSON.parse(JSON.stringify(this.tecnico));
  }

  updatePersonalData(){
    let data = {
      nombre: this.editedTecnico.nombre,
      apellido: this.editedTecnico.apellido,
      email: this.editedTecnico.email,
      legajo: this.editedTecnico.legajo,
      telefono: this.editedTecnico.telefono,
      domicilio: this.editedTecnico.domicilio,
      isAvailable: this.tecnico.isAvailable,
      provincia: this.editedTecnico.provincia,
      localidad: this.editedTecnico.localidad
    };
    this.service.updateTecnicoData(this.tecnico._id,data).subscribe(d=>{
      this.editedTecnico = null;
      this.ngOnInit();
    })
  }



  getStatusColor(status){
    switch(status){
      case "CANCELADO": return "#FE9AA2";
      case "FINALIZADO": return "#067E38";
      case "EN ESPERA": return "#B6C8EC";
      default: return "";

    }
  }


  eliminarTecnico(){
    this.confirm.confirm("Eliminar técnico", "Está seguro que desea eliminar al tecnico " + this.tecnico.nombre + " "  + this.tecnico.apellido + "?").then( confirmed =>{
      if(!confirmed) return;
      this.service.eliminarTecnico(this.tecnico._id).subscribe(d=>{
        this.router.navigate(['/tecnicos']);
      },
      err=>{
        this.toast.error("ERROR");
      })
    });
  }


  toggleIsAvailable(){
    this.editedTecnico = {
      nombre: this.tecnico.nombre,
      apellido: this.tecnico.apellido,
      email: this.tecnico.email,
      legajo: this.tecnico.legajo,
      telefono: this.tecnico.telefono,
      domicilio: this.tecnico.domicilio,
      isAvailable: !this.tecnico.isAvailable
    };
    this.tecnico.isAvailable = !this.tecnico.isAvailable;
    this.updatePersonalData();
  }

  premiar(){
    this.calificarTicket.calificar("Premiar / Sancionar Tecnico", "Indique un puntaje y comentarios a calificar al técnico " +  this.tecnico.nombre + " " + this.tecnico.apellido, "Calificar", "Cancelar").then(values=>{
      if(values.puntos!=0 && values.comentario.length>0){
        this.service.adminTecnicoReview(this.tecnico._id, values.comentario, values.puntos).subscribe(d=>{
          this.toast.success("Calificacion enviada con éxito");
        }, er=>{
          this.toast.error("ERROR");
        })
      }
      
    });
  }
  
  cambiarContrasena(){
    let password = prompt("Introduzca la nueva contraseña para el técnico. (mínimo 5 caracteres)");
    if(!password) return;
    if(password.length<5){
      return this.toast.error("Contraseña inválida");
    } 
    console.log(password);
    this.service.changePasswordTecnico(this.tecnico._id, password).subscribe(d=>{
      this.toast.success("Contraseña actualizada");
    },  er=>{
      this.toast.error(er.error);
    })
    
  }
}
